import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { StakedAssetFacade } from "@modules/staking/domain/+state/staked-asset.facade";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { StakingBannerUiModel } from "@modules/staking/domain/entities/staking-banner-ui.model";
import { StakingModalFlowModel } from "@modules/staking/domain/entities/staking-modal-flow.model";

@Component({
	selector: "app-staking-widget",
	templateUrl: "./staking-widget.component.html",
	styleUrls: ["./staking-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakingWidgetComponent {
	@Output() public openModalFlow: EventEmitter<StakingModalFlowModel> = new EventEmitter<StakingModalFlowModel>();
	@Input() public stakeableName: string = " ";
	public bannerUIModel$: Observable<StakingBannerUiModel> = this.stakedAssetFacade.getBannerData$();

	constructor(
		private readonly router: Router,
		private readonly route: ActivatedRoute,
		private readonly stakedAssetFacade: StakedAssetFacade
	) {}

	public openFlow(modalType: string, stakeable: Stakeable = null): void {
		if (stakeable) {
			this.openModalFlow.emit({ modalType, stakeable });
		} else {
			this.router.navigate([this.route.snapshot.parent.routeConfig.path, { outlets: { modal: modalType } }], {
				skipLocationChange: true
			});
		}
	}
}
